import 'regenerator-runtime/runtime'
import React from 'react'
import ReactDOM from 'react-dom/client'

if (import.meta.env.DEV) {
  const link = document.querySelector("link[rel='icon']");
  if (link) {
    link.setAttribute('href', '/icon-dev.svg');
  }
}
import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store'
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import { householdsRoutes } from './features/households/routes'
import { onboardingRoutes } from './features/onboarding/routes'
import { recipesRoutes } from './features/recipes/routes'
import './index.css';
import {authRoutes} from "@/features/auth/routes.jsx";
import {AuthBase} from "@/features/auth/components/AuthBase.jsx";
import {RequireAuth} from "@/features/auth/components/RequireAuth.jsx";
import {theme} from "@/theme.js";
import {usersRoutes} from "@/features/users/routes.jsx";
import {settingsRoutes} from "@/features/settings/routes.jsx";
import {ingredientsRoutes} from "@/features/ingredients/routes.jsx";
import {mealPlanRoutes} from "@/features/meals/meal-plan/routes.jsx";
import {shoppingListRoutes} from "@/features/shopping-list/routes.jsx";
import {myAccountRoutes} from "@/features/my-account/routes.jsx";
import {categoriesRoutes} from "@/features/categories/routes.jsx";
import {mealLogRoutes} from "@/features/meals/meal-log/routes.jsx";
import {mealRoutes} from "@/features/meals/routes.jsx";
import {FEATURE_FLAGS} from "@/featureFlags.js";

const router = createBrowserRouter([
  {
    path: "",
    element: <AuthBase />,
    children: [
      authRoutes,
      onboardingRoutes,
      householdsRoutes,
      {
        path: "/h/:householdId",
        element: <RequireAuth />,        
        children: [
          {
            path: '',
            element: <Navigate to="recipes" replace={true} />,
          },                              
          recipesRoutes,
          mealRoutes,
          mealPlanRoutes,
          ...(FEATURE_FLAGS.mealTracking ? [mealLogRoutes] : []),
          ingredientsRoutes,
          usersRoutes,
          settingsRoutes,
          shoppingListRoutes,
          myAccountRoutes,
          categoriesRoutes,
        ]
      },
    ]
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>    
    <Provider store={store}>
      <CssVarsProvider theme={theme} disableTransitionOnChange>
        <CssBaseline />
        <RouterProvider router={router} />    
      </CssVarsProvider>
    </Provider>
  </React.StrictMode>,
)
